import { createApp } from "vue";

import ArchiveSearchModal from "./components/ArchiveSearchModal.vue";

function initializeArchiveSearch() {
  // Initialize archive search modal if the container exists
  const archiveSearchContainer = document.getElementById(
    "archive-search-modal-container"
  );
  if (!archiveSearchContainer) {
    return;
  }

  const archiveUrl = archiveSearchContainer.dataset.archiveUrl;
  const placeholder = archiveSearchContainer.dataset.placeholder || "Search";
  const searchParam = archiveSearchContainer.dataset.searchParam || "q";
  const title = archiveSearchContainer.dataset.title || "Search archives";
  const username = archiveSearchContainer.dataset.username || "";

  // Extract username from archiveUrl if not provided
  let extractedUsername = username;
  if (!extractedUsername && archiveUrl) {
    // Archive URL format: /username/archive/ or /username/archive
    const match = archiveUrl.match(/\/([^\/]+)\/archive/);
    if (match) {
      extractedUsername = match[1];
    }
  }

  const app = createApp(ArchiveSearchModal, {
    archiveUrl,
    placeholder,
    searchParam,
    title,
    username: extractedUsername,
  });

  const modalInstance = app.mount(archiveSearchContainer);

  // Add event listeners to all search trigger buttons
  const attachListeners = () => {
    const searchTriggers = document.querySelectorAll(".archive-search-trigger");
    searchTriggers.forEach((trigger) => {
      trigger.addEventListener("click", () => {
        if (modalInstance && typeof modalInstance.open === "function") {
          modalInstance.open();
        }
      });
    });
  };

  // Attach listeners immediately if DOM is ready, otherwise wait
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", attachListeners);
  } else {
    attachListeners();
  }
}

// Initialize when script loads
initializeArchiveSearch();
